﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get targets() {
        return ["checkbox"];
    }

    connect() {
        this.ensureOneChecked();
    }

    ensureOneChecked() {
        const checkedCheckboxTargets = this.checkboxTargets.filter(ct => ct.checked);

        if (checkedCheckboxTargets.length === 1) {
            const checkedCheckboxTarget = checkedCheckboxTargets[0];
            checkedCheckboxTarget.disabled = true;
            const hiddenInput = document.createElement("input");
            hiddenInput.type = "hidden";
            hiddenInput.name = checkedCheckboxTarget.name;
            hiddenInput.value = checkedCheckboxTarget.value;
            checkedCheckboxTarget.parentNode.insertBefore(hiddenInput, checkedCheckboxTarget);
            checkedCheckboxTarget.hiddenInput = hiddenInput;
        } else {
            for (const checkedCheckboxTarget of checkedCheckboxTargets) {
                checkedCheckboxTarget.disabled = false;
                checkedCheckboxTarget.hiddenInput?.remove();
            }
        }
    }
}